import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Grid,
  Divider,
  Select,
  MenuItem,
  FormControl,
  Box,
  Tooltip,
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const FYDetailsSection = ({ fyDetails = [], note }) => {
  const [selectedFY, setSelectedFY] = useState(fyDetails?.[0]?.title || '');
  const selectedData =
    fyDetails?.find((fy) => fy.title === selectedFY) || fyDetails?.[0] || null;
  const noDataAvailable = !fyDetails || fyDetails.length === 0;
  return (
    <Box>
      {noDataAvailable ? (
        <Paper
          elevation={0}
          sx={{ p: 2, textAlign: 'center' }}
        >
          <Typography
            variant='body1'
            sx={{ color: '#666' }}
          >
            No data available
          </Typography>
        </Paper>
      ) : (
        <>
          <Typography
            variant='labelS'
            sx={{ color: '#666', mb: 0.5 }}
          >
            Financial Year
          </Typography>
          <FormControl
            fullWidth
            sx={{ mb: 0.5 }}
          >
            <Select
              value={selectedFY}
              onChange={(e) => setSelectedFY(e.target.value)}
              displayEmpty
              size='small'
              renderValue={(value) =>
                value || fyDetails?.[0]?.title || 'Select Financial Year'
              }
            >
              {fyDetails?.map((fy) => (
                <MenuItem
                  key={fy.title}
                  value={fy.title}
                >
                  {fy.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedData && (
            <Paper
              elevation={0}
              sx={{ py: 2 }}
            >
              <Grid
                container
                sx={{ mb: 2 }}
              >
                <Grid
                  item
                  xs={8}
                >
                  <Typography variant='labelD'>Time Period</Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                >
                  <Typography
                    variant='labelD'
                    textAlign='right'
                  >
                    Amount
                  </Typography>
                </Grid>
              </Grid>
              {selectedData.details?.map((item, idx) => (
                <Grid
                  container
                  key={idx}
                  sx={{ mb: 2 }}
                >
                  <Grid
                    item
                    xs={8}
                  >
                    <Typography variant='body1'>{item.display_name}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        variant='body1'
                        textAlign='right'
                        sx={{ mr: 1 }}
                      >
                        {item.value}
                      </Typography>
                      {item?.message && (
                        <Tooltip
                          title={item?.message}
                          arrow
                          placement='top'
                          enterTouchDelay={0}
                          leaveTouchDelay={1500}
                          disableFocusListener={false}
                          disableTouchListener={false}
                          disableHoverListener={false}
                        >
                          <InfoOutlined sx={{ fontSize: '16px' }} />
                        </Tooltip>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              ))}

              {selectedData.total && (
                <>
                  <Divider sx={{ my: 1 }} />
                  <Grid
                    container
                    sx={{ mb: 1 }}
                  >
                    <Grid
                      item
                      xs={8}
                    >
                      <Typography variant='body1'>
                        {selectedData.total.display_name}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                    >
                      <Typography
                        variant='body1'
                        textAlign='right'
                      >
                        {selectedData.total.value}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                    >
                      {note && (
                        <Typography
                          variant='p3'
                          sx={{ color: '#CC0000' }}
                        >
                          {note}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
            </Paper>
          )}
        </>
      )}
    </Box>
  );
};

export default FYDetailsSection;
